import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'sigecom-pagination-list',
  templateUrl: './pagination-list.component.html',
  styleUrls: ['./pagination-list.component.scss'],
})
export class PaginationListComponent implements OnInit, OnChanges {
  @Input() currentPage: number = 0;
  @Input() totalPages: number = 0;
  @Input() maxDisplayedPages: number = 0;

  @Output() pageChange = new EventEmitter<number>();

  public page: number = 0;
  public displayedPages: number[] = [];
  public lastDisplayedPage = 0;

  constructor() {}

  public ngOnInit(): void {
    this.displayListOfPages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalPages'] && changes['totalPages'].currentValue) {
      this.resetPagination();
      this.displayListOfPages();
    }

    if (
      changes['currentPage'] &&
      changes['currentPage'].currentValue === 0 &&
      !changes['currentPage'].firstChange
    ) {
      this.resetPagination();
      this.displayListOfPages();
    }
  }

  public displayListOfPages() {
    const lastLenghtOfdisplayedPages = this.totalPages % this.maxDisplayedPages;

    this.displayedPages = Array.from(
      {
        length:
          this.lastDisplayedPage + this.maxDisplayedPages > this.totalPages
            ? lastLenghtOfdisplayedPages
            : this.maxDisplayedPages,
      },
      (_, i) => this.lastDisplayedPage + i + 1,
    );

    return this.displayedPages;
  }

  public prevPage(): void {
    if (this.page > 0) {
      this.goToPage(this.page - 1);
    }

    this.displayListOfPages();
  }

  public nextPage(): void {
    const limitPage = this.page + 1;

    if (limitPage < this.totalPages) {
      this.page += 1;
      this.pageChange.emit(limitPage);
    }

    if (this.lastDisplayedPage < this.totalPages - this.maxDisplayedPages) {
      this.lastDisplayedPage =
        this.displayedPages[this.displayedPages.length - 1];

      this.displayListOfPages();
    }
  }

  public resetPagination(): void {
    this.lastDisplayedPage = 0;
    this.page = 0;
  }

  public goToPage(page: number): void {
    this.page = page;

    const firstVisiblePage = this.lastDisplayedPage + 1;
    const lastVisiblePage = this.lastDisplayedPage + this.maxDisplayedPages;

    if (this.page + 1 < firstVisiblePage || this.page + 1 > lastVisiblePage) {
      this.lastDisplayedPage =
        Math.floor(this.page / this.maxDisplayedPages) * this.maxDisplayedPages;
      this.displayListOfPages();
    }

    this.pageChange.emit(page);
  }

  private adjustPagination() {}

  get currentPageLabel(): number {
    return this.page + 1;
  }
}
